module.exports = __webpack_public_path__ + "static/media/port.de6a3480.png";